import React, { FC } from "react";
import FinllieLogo from "./FinllieLogo";
import "./FinllieLoader.css";

interface FinllieLoaderProps {
  /** Message shown below the icon */
  text?: string;
  /** If true: covers the whole viewport (fixed). If false: covers nearest relative parent */
  fullscreen?: boolean;
}

const FinllieLoader: FC<FinllieLoaderProps> = ({
  text = "Please wait...",
  fullscreen = true,
}) => (
  <div className={`fnl-loader-overlay ${fullscreen ? "fnl-loader-fixed" : "fnl-loader-absolute"}`}>
    <div className="fnl-loader-inner">
      {/* Pulsing favicon */}
      <div className="fnl-loader-icon-wrap">
        <FinllieLogo size={64} animate />
        {/* Ripple ring behind the icon */}
        <span className="fnl-loader-ripple fnl-r1" />
        <span className="fnl-loader-ripple fnl-r2" />
      </div>

      {/* Progress bar */}
      <div className="fnl-loader-bar-track">
        <div className="fnl-loader-bar-fill" />
      </div>

      {text && <span className="fnl-loader-text">{text}</span>}
    </div>
  </div>
);

export default FinllieLoader;